




import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class HeaderMenuLink extends Vue {
  @Prop() private link!: string;
  @Prop() private text!: string;
}
